import React from "react";

function Loader({ loading }: { loading?: boolean }) {
  if (!loading) {
    return <></>;
  }
  return (
    <div className="w-full flex items-center justify-center">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
